import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spinner = ({ inline }) => (
  <div className={classNames('spinner-wrapper', { inline })}>
    {!inline && <div className="overlay" />}
    <div className="spinner" />
  </div>
);

Spinner.propTypes = {
  inline: PropTypes.bool
};

export default Spinner;
